import { React, useState, useEffect } from "react";

const PopUpGalaxyResults = ({ resultsData, catMid, marketType }) => {

    console.log("GALAXY COMPONENT:", resultsData);
    console.log("GALAXY RATE JSON:", resultsData?.bet?.rateJson);

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    if (!resultsData) return null;

    const dataObj = resultsData;

    const formatDate = (date) =>
        new Date(date).toLocaleString("en-US", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        });

    let SevenDown = "";
    let Seven = "";
    let SevenUp = "";
    let isRedWinner = "";
    let isBlackWinner = "";
    let isOddWinner = "";
    let isEvenWinner = "";
    let isClubWinner = "";
    let isDiamondWinner = "";
    let isSpadeWinner = "";
    let isHeartWinner = "";
    let oneTwoThreeWinner = "";
    let fourFiveSixWinner = "";
    let eightNineTenWinner = "";
    let jackQueenKingWinner = "";
    let luckyNumberWinner = "";
    let aceWinner = "";
    let twoWinner = "";
    let threeWinner = "";
    let fourWinner = "";
    let fiveWinner = "";
    let sixWinner = "";
    let sevenWinner = "";
    let eightWinner = "";
    let nineWinner = "";
    let tenWinner = "";
    let jackWinner = "";
    let queenWinner = "";
    let kingWinner = "";

    let playerA = "";
    let playerB = "";
    let playerAPlus = "";
    let playerBPlus = "";
    let allABlack = "";
    let allARed = "";
    let allBBlack = "";
    let allBRed = "";
    let greater21A = "";
    let equal21A = "";
    let less21A = "";
    let greater21B = "";
    let equal21B = "";
    let less21B = "";
    let bonus333 = "";
    let playerACards = [];
    let playerBCards = [];

    let high = "";
    let snap = "";
    let low = "";
    let red = "";
    let black = "";
    let card2345 = "";
    let card6789 = "";
    let cardJQKA = "";
    let communityCards = [];

    let Andar = "";
    let Bahar = "";
    let baharCards = [];
    let andarCards = [];

    let dragon = "";
    let tiger = "";
    let tie = "";
    let dragonEven = "";
    let dragonOdd = "";
    let tigerEven = "";
    let tigerOdd = "";
    let dragonRed = "";
    let dragonBlack = "";
    let tigerRed = "";
    let tigerBlack = "";
    let dragonSpades = "";
    let dragonHearts = "";
    let dragonClubs = "";
    let dragonDiamonds = "";
    let tigerSpades = "";
    let tigerHearts = "";
    let tigerClubs = "";
    let tigerDiamonds = "";


    if (marketType == 47) {

        const winners = dataObj.resultTxt
            ? dataObj.resultTxt.split(",").map(item => item.trim())
            : [];

        const card = dataObj.c1 || "";

        let numberVal = "";

        if (card !== "") {
            numberVal = card.slice(0, -2);

            if (numberVal === "J") {
                numberVal = 11;
            } else if (numberVal === "Q") {
                numberVal = 12;
            } else if (numberVal === "K") {
                numberVal = 13;
            } else if (numberVal === "A") {
                numberVal = "A";
            } else {
                numberVal = parseInt(numberVal);
            }
        }

        SevenDown = winners.includes("7 Down") ? "WINNER" : "LOSER";
        Seven = winners.includes("7") ? "WINNER" : "LOSER";
        SevenUp = winners.includes("7 Up") ? "WINNER" : "LOSER";

        isRedWinner = winners.includes("Red") ? "WINNER" : "LOSER";
        isBlackWinner = winners.includes("Black") ? "WINNER" : "LOSER";

        isOddWinner = winners.includes("Odd") ? "WINNER" : "LOSER";
        isEvenWinner = winners.includes("Even") ? "WINNER" : "LOSER";

        isClubWinner = winners.includes("Clubs") ? "WINNER" : "LOSER";
        isDiamondWinner = winners.includes("Diamonds") ? "WINNER" : "LOSER";
        isSpadeWinner = winners.includes("Spades") ? "WINNER" : "LOSER";
        isHeartWinner = winners.includes("Hearts") ? "WINNER" : "LOSER";

        oneTwoThreeWinner = winners.includes("123") ? "WINNER" : "LOSER";
        fourFiveSixWinner = winners.includes("456") ? "WINNER" : "LOSER";
        eightNineTenWinner = winners.includes("8910") ? "WINNER" : "LOSER";
        jackQueenKingWinner = winners.includes("JQK") ? "WINNER" : "LOSER";

        aceWinner = numberVal === "A" ? "WINNER" : "LOSER";
        twoWinner = numberVal === 2 ? "WINNER" : "LOSER";
        threeWinner = numberVal === 3 ? "WINNER" : "LOSER";
        fourWinner = numberVal === 4 ? "WINNER" : "LOSER";
        fiveWinner = numberVal === 5 ? "WINNER" : "LOSER";
        sixWinner = numberVal === 6 ? "WINNER" : "LOSER";
        sevenWinner = numberVal === 7 ? "WINNER" : "LOSER";
        eightWinner = numberVal === 8 ? "WINNER" : "LOSER";
        nineWinner = numberVal === 9 ? "WINNER" : "LOSER";
        tenWinner = numberVal === 10 ? "WINNER" : "LOSER";
        jackWinner = numberVal === 11 ? "WINNER" : "LOSER";
        queenWinner = numberVal === 12 ? "WINNER" : "LOSER";
        kingWinner = numberVal === 13 ? "WINNER" : "LOSER";
    }

    if (marketType == 50) {

        let i = 1;
        while (dataObj[`ac${i}`]) {
            playerACards.push(dataObj[`ac${i}`]);
            i++;
        }

        i = 1;
        while (dataObj[`bc${i}`]) {
            playerBCards.push(dataObj[`bc${i}`]);
            i++;
        }

        playerA = dataObj.resultTxt === "Player A" ? "WINNER" : "LOSER";
        playerB = dataObj.resultTxt === "Player B" ? "WINNER" : "LOSER";

        playerAPlus =
            dataObj.isTrail1 ||
                dataObj.isPureSequence1 ||
                dataObj.isSequence1 ||
                dataObj.isPair1
                ? "WINNER"
                : "LOSER";

        playerBPlus =
            dataObj.isTrail2 ||
                dataObj.isPureSequence2 ||
                dataObj.isSequence2 ||
                dataObj.isPair2
                ? "WINNER"
                : "LOSER";

        allABlack = dataObj.isColor1 == 1 ? "WINNER" : "LOSER";
        allARed = dataObj.isColor1 == 2 ? "WINNER" : "LOSER";

        allBBlack = dataObj.isColor2 == 1 ? "WINNER" : "LOSER";
        allBRed = dataObj.isColor2 == 2 ? "WINNER" : "LOSER";

        greater21A = dataObj.cardRank1 > 21 ? "WINNER" : "LOSER";
        equal21A = dataObj.cardRank1 == 21 ? "WINNER" : "LOSER";
        less21A = dataObj.cardRank1 < 21 ? "WINNER" : "LOSER";

        greater21B = dataObj.cardRank2 > 21 ? "WINNER" : "LOSER";
        equal21B = dataObj.cardRank2 == 21 ? "WINNER" : "LOSER";
        less21B = dataObj.cardRank2 < 21 ? "WINNER" : "LOSER";

        bonus333 =
            dataObj.isTrail1 ||
                dataObj.isTrail2
                ? "WINNER"
                : "LOSER";
    }

    if (marketType == 51) {

        const winners = dataObj.resultTxt
            ? dataObj.resultTxt.split(",").map(item => item.trim())
            : [];

        communityCards = [];

        let i = 1;
        while (dataObj[`c${i}`]) {
            communityCards.push(dataObj[`c${i}`]);
            i++;
        }

        high = winners.includes("High") ? "WINNER" : "LOSER";
        low = winners.includes("Low") ? "WINNER" : "LOSER";
        snap = winners.includes("Snap") ? "WINNER" : "LOSER";

        red = winners.includes("Red") ? "WINNER" : "LOSER";
        black = winners.includes("Black") ? "WINNER" : "LOSER";

        card2345 = winners.includes("2345") ? "WINNER" : "LOSER";
        card6789 = winners.includes("6789") ? "WINNER" : "LOSER";
        cardJQKA = winners.includes("JQKA") ? "WINNER" : "LOSER";
    }

    if (marketType == 48) {

        const allCards = dataObj.cards_desc
            ? dataObj.cards_desc.split(",").map(card => card.trim())
            : [];

        andarCards = [];
        baharCards = [];

        allCards.forEach((card, index) => {
            if (index % 2 === 0) {
                baharCards.push(card);
            } else {
                andarCards.push(card);
            }
        });

        Bahar = dataObj.resultTxt === "Bahar"
            ? "WINNER"
            : "LOSER";

        Andar = dataObj.resultTxt === "Andar"
            ? "WINNER"
            : "LOSER";
    }

    if (marketType == 49) {

        const winners = dataObj.resultTxt
            ? dataObj.resultTxt.split(",").map(item => item.trim())
            : [];

        dragon = winners.includes("Dragon") ? "WINNER" : "LOSER";
        tiger = winners.includes("Tiger") ? "WINNER" : "LOSER";
        tie = winners.includes("Tie") ? "WINNER" : "LOSER";

        dragonEven = winners.includes("Dragon-Even") ? "WINNER" : "LOSER";
        dragonOdd = winners.includes("Dragon-Odd") ? "WINNER" : "LOSER";

        tigerEven = winners.includes("Tiger-Even") ? "WINNER" : "LOSER";
        tigerOdd = winners.includes("Tiger-Odd") ? "WINNER" : "LOSER";

        dragonRed = winners.includes("Dragon-Red") ? "WINNER" : "LOSER";
        dragonBlack = winners.includes("Dragon-Black") ? "WINNER" : "LOSER";

        tigerRed = winners.includes("Tiger-Red") ? "WINNER" : "LOSER";
        tigerBlack = winners.includes("Tiger-Black") ? "WINNER" : "LOSER";

        dragonSpades = winners.includes("Dragon - Spades") ? "WINNER" : "LOSER";
        dragonHearts = winners.includes("Dragon - Hearts") ? "WINNER" : "LOSER";
        dragonClubs = winners.includes("Dragon - Clubs") ? "WINNER" : "LOSER";
        dragonDiamonds = winners.includes("Dragon - Diamonds") ? "WINNER" : "LOSER";

        tigerSpades = winners.includes("Tiger - Spades") ? "WINNER" : "LOSER";
        tigerHearts = winners.includes("Tiger - Hearts") ? "WINNER" : "LOSER";
        tigerClubs = winners.includes("Tiger - Clubs") ? "WINNER" : "LOSER";
        tigerDiamonds = winners.includes("Tiger - Diamonds") ? "WINNER" : "LOSER";
    }

    return (
        <div id="GalaxyResults" className="site_family">

            <div id="lucky-jet" style={{ display: marketType == 52 ? "" : "none" }}>
                <div className="card">
                    <div className="card-header">
                        Market Start Time = <b>{formatDate(dataObj.evt_od)}</b>
                    </div>
                    <div className="card-body text-center">
                        <div
                            style={{
                                color: "#dc143c",
                                fontSize: 28,
                                fontWeight: 700,
                                marginBottom: 25,
                                textShadow: "0 2px 4px rgba(0,0,0,.25)"
                            }}
                        >
                            CRASHED AT!
                        </div>

                        <div
                            style={{
                                color: "#dc143c",
                                fontSize: 110,
                                fontWeight: 900,
                                lineHeight: 1,
                                textShadow: "3px 3px 0 #000"
                            }}
                        >
                            {dataObj.result}x
                        </div>

                    </div>
                </div>
            </div>

            <div id="lucky7-galaxy" style={{ display: marketType == 47 ? "" : "none" }}>
                <div className="card">
                    <div className="card-header">
                        Market Start Time = <b>{formatDate(dataObj.evt_od)}</b>
                    </div>
                    <div className="card-body">
                        <div className="player-item">
                            <b>
                                <span className="name" style={{ color: "#000" }}>
                                    Community Cards
                                </span>
                            </b>
                            <div className="player-card">
                                <div className="BFBCardHandViewDealerab" style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%",
                                }}>
                                    <div
                                        className="BFBCardFanViewab"
                                        style={{
                                            justifyContent: "center",
                                            padding: "5px"
                                        }}
                                    >
                                        <div className="RSMImageView2ab">
                                            <img
                                                src={`/assets/images/cards/${dataObj.c1}.svg`}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "55px",
                                                    height: "auto"
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">

                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    7 Up
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: SevenUp === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {SevenUp}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    7
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: Seven === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {Seven}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    7 Down
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: SevenDown === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {SevenDown}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Red
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isRedWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isRedWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Black
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isBlackWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isBlackWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Odd
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isOddWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isOddWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Even
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isEvenWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isEvenWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Club
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isClubWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isClubWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Diamond
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isDiamondWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isDiamondWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Heart
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isHeartWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isHeartWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    Spade
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: isSpadeWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {isSpadeWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    A,2,3
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: oneTwoThreeWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {oneTwoThreeWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    4,5,6
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: fourFiveSixWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {fourFiveSixWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    8,9,10
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: eightNineTenWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {eightNineTenWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                    J,Q,K
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: jackQueenKingWinner === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                    {jackQueenKingWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>A</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: aceWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {aceWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>2</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: twoWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {twoWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>3</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: threeWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {threeWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>4</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: fourWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {fourWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>5</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: fiveWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {fiveWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>6</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: sixWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {sixWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>7</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: sevenWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {sevenWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>8</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: eightWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {eightWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>9</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: nineWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {nineWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>10</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: tenWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {tenWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>J</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: jackWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {jackWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>Q</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: queenWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {queenWinner}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div style={{ fontSize: "22px", fontWeight: "700" }}>K</div>
                                <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: kingWinner === "WINNER" ? "#28a745" : "#666" }}>
                                    {kingWinner}
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>

            <div id="tp20-galaxy" style={{ display: marketType == 50 ? "" : "none" }}>
                <div className="card">

                    <div className="card-header">
                        Market Start Time = <b>{formatDate(dataObj.evt_od)}</b>
                    </div>

                    <div className="card-body">
                        <div className="row">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>Player A</span>
                                    </b>

                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    display: "flex",
                                                    gap: "8px",
                                                    padding: "8px"
                                                }}
                                            >
                                                {playerACards.map((card, index) => (
                                                    <div className="RSMImageView2ab" key={index}>
                                                        <img
                                                            src={`/assets/images/cards/${card}.svg`}
                                                            style={{ width: "55px" }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>Player B</span>
                                    </b>

                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    display: "flex",
                                                    gap: "8px",
                                                    padding: "8px"
                                                }}
                                            >
                                                {playerBCards.map((card, index) => (
                                                    <div className="RSMImageView2ab" key={index}>
                                                        <img
                                                            src={`/assets/images/cards/${card}.svg`}
                                                            style={{ width: "55px" }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Player A
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: playerA === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {playerA}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Player B
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: playerB === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {playerB}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Player A+
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: playerAPlus === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {playerAPlus}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Player B+
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: playerBPlus === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {playerBPlus}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                ALL A BLACK
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: allABlack === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {allABlack}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                ALL A RED
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: allARed === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {allARed}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                ALL B BLACK
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: allBBlack === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {allBBlack}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                ALL B RED
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: allBRed === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {allBRed}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                &gt;21 (A)
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: greater21A === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {greater21A}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                21 (A)
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: equal21A === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {equal21A}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                &lt;21 (A)
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: less21A === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {less21A}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                &gt;21 (B)
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: greater21B === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {greater21B}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                21 (B)
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: equal21B === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {equal21B}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                &lt;21 (B)
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: less21B === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {less21B}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                3+3 BONUS
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: bonus333 === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {bonus333}
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div id="hilo-galaxy" style={{ display: marketType == 51 ? "" : "none" }}>
                <div className="card">

                    <div className="card-header">
                        Market Start Time = <b>{formatDate(dataObj.evt_od)}</b>
                    </div>

                    <div className="card-body">
                        <div className="row">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>Community Cards</span>
                                    </b>

                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    display: "flex",
                                                    gap: "8px",
                                                    padding: "8px"
                                                }}
                                            >
                                                {communityCards.map((card, index) => (
                                                    <div className="RSMImageView2ab" key={index}>
                                                        <img
                                                            src={`/assets/images/cards/${card}.svg`}
                                                            style={{ width: "55px" }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                High
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: high === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {high}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Snap
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: snap === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {snap}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Low
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: low === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {low}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Red
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: red === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {red}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Black
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: black === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {black}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                2345
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: card2345 === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {card2345}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                6789
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: card6789 === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {card6789}
                            </div>
                        </div>

                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                JQKA
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: "600", marginTop: "4px", color: cardJQKA === "WINNER" ? "#28a745" : "#666", textTransform: "uppercase" }}>
                                {cardJQKA}
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div id="andar-bahar-galaxy" style={{ display: marketType == 48 ? "" : "none" }}>
                <div className="card">
                    <div className="card-header">
                        Market Start Time = <b>{formatDate(dataObj.evt_od)}</b>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>
                                            Community Cards
                                        </span>
                                    </b>
                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    justifyContent: "center",
                                                    padding: "8px"
                                                }}
                                            >
                                                <div className="RSMImageView2ab">
                                                    <img
                                                        src={`/assets/images/cards/${dataObj.j1}.svg`}
                                                        style={{
                                                            width: "100%",
                                                            maxWidth: "55px",
                                                            height: "auto"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>
                                            Bahar
                                        </span>
                                    </b>
                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "8px",
                                                    padding: "8px"
                                                }}
                                            >
                                                {baharCards.map((card, index) => (

                                                    <div
                                                        className="RSMImageView2ab"
                                                        key={index}
                                                    >

                                                        <img
                                                            src={`/assets/images/cards/${card}.svg`}
                                                            style={{
                                                                width: "55px"
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>
                                            Andar
                                        </span>
                                    </b>
                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "8px",
                                                    padding: "8px"
                                                }}
                                            >
                                                {andarCards.map((card, index) => (
                                                    <div
                                                        className="RSMImageView2ab"
                                                        key={index}
                                                    >
                                                        <img
                                                            src={`/assets/images/cards/${card}.svg`}
                                                            style={{
                                                                width: "55px"
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-6 mb-3 text-center">
                                <div
                                    style={{
                                        fontSize: "22px",
                                        fontWeight: "700"
                                    }}
                                >
                                    Bahar
                                </div>
                                <div
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "600",
                                        marginTop: "4px",
                                        color: Bahar === "WINNER" ? "#28a745" : "#666",
                                        textTransform: "uppercase"
                                    }}
                                >
                                    {Bahar}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3 text-center">
                                <div
                                    style={{
                                        fontSize: "22px",
                                        fontWeight: "700"
                                    }}
                                >
                                    Andar
                                </div>
                                <div
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "600",
                                        marginTop: "4px",
                                        color: Andar === "WINNER" ? "#28a745" : "#666",
                                        textTransform: "uppercase"
                                    }}
                                >
                                    {Andar}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="dragon-tiger-galaxy" style={{ display: marketType == 49 ? "" : "none" }}>
                <div className="card">
                    <div className="card-header">
                        Market Start Time = <b>{formatDate(dataObj.evt_od)}</b>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div
                                className="col-12"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>
                                            Dragon
                                        </span>
                                    </b>
                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    justifyContent: "center",
                                                    padding: "8px"
                                                }}                                            >
                                                <div className="RSMImageView2ab">
                                                    <img
                                                        src={`/assets/images/cards/${dataObj.c1}.svg`}
                                                        style={{
                                                            width: "55px"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-12 mt-4"
                                style={{ margin: "auto", textAlign: "center" }}
                            >
                                <div className="player-item">
                                    <b>
                                        <span className="name" style={{ color: "#000" }}>
                                            Tiger
                                        </span>
                                    </b>
                                    <div className="player-card">
                                        <div className="BFBCardHandViewDealerab">
                                            <div
                                                className="BFBCardFanViewab"
                                                style={{
                                                    justifyContent: "center",
                                                    padding: "8px"
                                                }}
                                            >
                                                <div className="RSMImageView2ab">
                                                    <img
                                                        src={`/assets/images/cards/${dataObj.c2}.svg`}
                                                        style={{
                                                            width: "55px"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragon === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragon}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tiger === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tiger}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tie
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tie === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tie}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Even
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonEven === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonEven}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Odd
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonOdd === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonOdd}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Even
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerEven === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerEven}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Odd
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerOdd === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerOdd}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Red
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonRed === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonRed}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Black
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonBlack === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonBlack}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Red
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerRed === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerRed}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Black
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerBlack === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerBlack}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Spades
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonSpades === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonSpades}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Hearts
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonHearts === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonHearts}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Clubs
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonClubs === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonClubs}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Dragon - Diamonds
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: dragonDiamonds === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {dragonDiamonds}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Spades
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerSpades === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerSpades}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Hearts
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerHearts === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerHearts}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Clubs
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerClubs === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerClubs}
                            </div>
                        </div>
                        <div className="col-md-6 mb-3 text-center">
                            <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                Tiger - Diamonds
                            </div>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginTop: "4px",
                                color: tigerDiamonds === "WINNER" ? "#28a745" : "#666",
                                textTransform: "uppercase"
                            }}>
                                {tigerDiamonds}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <style>
                {`
                    .player-card {
                        border-radius: 12px;
                        border: 1px solid rgb(14 99 8 / 25%);
                    }
                    #lucky7-galaxy .player-card,
                    #andar-bahar-galaxy .player-card,
                    #tp20-galaxy .player-card,
                    #dragon-tiger-galaxy .player-card,
                     #hilo-galaxy .player-card{
                        background: none;
                        padding: 0 !important;
                    }
              `}
            </style>
        </div>
    );
};

export default PopUpGalaxyResults;